import PropTypes from 'prop-types';
import FullObjectSelection from '../FullObjectSelection/FullObjectSelection';
import UsersUnassigned from './UsersUnassigned';
import UsersAssigned from './UsersAssigned';

function UserSelection({
  filters = {},
  selected = [],
  allowCustomOrder = false,
  allowChanges = false,
  customToolbar = null,
  assigning = false,
  onChange = () => {},
}) {
  if (assigning) {
    return (
      <FullObjectSelection className="UserSelection">
        <UsersUnassigned
          selected={selected}
          customToolbar={customToolbar}
          filters={filters}
          onChange={onChange}
        />
      </FullObjectSelection>
    );
  }

  return (
    <FullObjectSelection className="UserSelection">
      <UsersAssigned
        selected={selected}
        allowCustomOrder={allowCustomOrder}
        allowChanges={allowChanges}
        customToolbar={customToolbar}
        onChange={onChange}
      />
    </FullObjectSelection>
  );
}

UserSelection.propTypes = {
  /** Filters for the fetch method */
  filters: PropTypes.oneOfType([
    PropTypes.object,
  ]),
  /** Selected objects */
  selected: PropTypes.arrayOf(PropTypes.object),
  /** Allow custom order of objects in the assigned table */
  allowCustomOrder: PropTypes.bool,
  /** Allow changes to the object selection */
  allowChanges: PropTypes.bool,
  /** Custom toolbar for assigned locations */
  customToolbar: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  /** Selector is assigning objects */
  assigning: PropTypes.bool,
  /** When the objects are changed */
  onChange: PropTypes.func,
};

export default UserSelection;
